import * as types from './types';
import * as actionTypes from './constants';
import { IAction } from '@state/types';

const defaultState: types.IUserConfigState = { };

const designTypeReducer = (
  state: types.IUserConfigState = defaultState, 
  action: IAction | types.ISetUserConfigAction
) => {
  switch ((action as IAction).type) {
    case actionTypes.SET_USERCONFIG_INFO: {
      return {...state, userConfig: (action as types.ISetUserConfigAction).userConfig};
    }
    case actionTypes.ADD_SUCCESS: {
      return {...state, response: (action as types.IServerSuccessAction).response};
    }
    default: {
      return state;
    }
  }
};


export default designTypeReducer;
